module.exports = __webpack_public_path__ + "static/media/res2.60a150fe.png";